/**
 * Centralized Application Constants
 */

export const ROLES = {
    SUPER_ADMIN: 'superAdmin',
    ADMIN: 'admin',
    SAP_EXECUTIVE: 'sapExecutive',
    INSPECTION_WORKER: 'inspectionWorker',
    MAINTENANCE_OPERATOR: 'maintenceOperator', // Note: Preserving the typo 'maintence' from legacy code
    SHIFT_MANAGER: 'shiftManager',
    CHIEF_MACHINERY: 'chiefMachinery',
    OBSERVER: 'observer',
    SUPERVISOR: 'supervisor',
    TEST_ROLE: 'TestRole',
    OPERATOR: 'operator',
    OPERATOR_INSPECTOR_UNIVERSAL: 'OperatorInspectorUniversal',
    OPERATOR_MACHINERY_UNIVERSAL: 'OperatorMachineryUniversal',
    OPERATOR_INSPECTOR: 'OperatorInspector'
}

export const ROLES_DISPLAY_NAMES = {
    [ROLES.SUPER_ADMIN]: 'Super Administrador',
    [ROLES.ADMIN]: 'Administrador',
    [ROLES.SAP_EXECUTIVE]: 'Ejecutivo SAP',
    [ROLES.INSPECTION_WORKER]: 'Operario de Inspección',
    [ROLES.MAINTENANCE_OPERATOR]: 'Operario de Mantención',
    [ROLES.SHIFT_MANAGER]: 'Jefe de turno - Inspección y Mantención',
    [ROLES.CHIEF_MACHINERY]: 'Jefe de maquinaria',
    [ROLES.OBSERVER]: 'Observador',
    [ROLES.SUPERVISOR]: 'Supervisor',
    [ROLES.TEST_ROLE]: 'Rol de Prueba',
    [ROLES.OPERATOR_INSPECTOR_UNIVERSAL]: 'Operario Inspector Universal',
    [ROLES.OPERATOR_MACHINERY_UNIVERSAL]: 'Jefe de Maquinaria Universal',
    [ROLES.OPERATOR_INSPECTOR]: 'Operario Inspector'
}

export const REPORT_STATUS = {
    ASSIGN: 'Asignar',
    IN_PROCESS: 'En proceso',
    TO_CLOSE: 'Por cerrar',
    COMPLETED: 'Completadas',
    ORIGIN: 'Origen'
}

export const REPORT_TYPE = {
    INSPECTION: 'Inspección',
    MAINTENANCE: 'Mantención'
}
